export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
  ENDPOINTS: {
    LOGIN: process.env.REACT_APP_LOGIN_ENDPOINT || '/vendor/login',
    PACKAGES: process.env.REACT_APP_PACKAGES_ENDPOINT || '/vendor/package',
    HOLIDAY_PACKAGES: process.env.REACT_APP_HOLIDAY_PACKAGES_ENDPOINT || '/vendor/package',
    DATE_SLOTS: process.env.REACT_APP_DATE_SLOTS_ENDPOINT || '/vendor/date-slots',
    CHANGE_PASSWORD: process.env.REACT_APP_CHANGE_PASSWORD_ENDPOINT || '/vendor/changePassword',
    FORGOT_PASSWORD: process.env.REACT_APP_FORGOT_PASSWORD_ENDPOINT || '/vendor/forgotPassword',
    DASHBOARD: process.env.REACT_APP_DASHBOARD_ENDPOINT || '/vendor/dashboard',
    BOOKINGS: process.env.REACT_APP_BOOKINGS_ENDPOINT || '/vendor/bookings',
  }
};

export const API_URLS = {
  BASE_URL: API_CONFIG.BASE_URL,
  LOGIN: `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.LOGIN}`,
  PACKAGES: `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.PACKAGES}`,
  HOLIDAY_PACKAGES: `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.HOLIDAY_PACKAGES}`,
  DATE_SLOTS: `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.DATE_SLOTS}`,
  CHANGE_PASSWORD: `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.CHANGE_PASSWORD}`,
  FORGOT_PASSWORD: `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.FORGOT_PASSWORD}`,
  DASHBOARD: `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.DASHBOARD}`,
  BOOKINGS: `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.BOOKINGS}`,
};
